import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { setTableState } from '../redux/actions/tableActions';

export const useTableState = (tableName) => {
    const dispatch = useDispatch();
    const tableState = useSelector(state => state.tableState[tableName]);

    const updateTableState = useCallback((newState) => {
        dispatch(setTableState(tableName, newState));
    }, [dispatch, tableName]);

    return [tableState, updateTableState];
};